export default function headerRequest() {
    let user = JSON.parse(localStorage.getItem("infoAssist"));
    if (user && user.token) {
      return { 'Authorization': "Bearer " + user.token };
    }
}